// Sharing a result: the link it carries (a challenge to fight the same
// opponents) and the loader for the share card itself, which draws the image
// and hands it to the share sheet from a chunk of its own (share-card.ts).
// The result screen loads it as soon as a result can be shared, so a tap
// on Share never waits for it.

import { currentLang } from '@/i18n';

export const GAME_URL = 'https://kiai.karate.berlin/';

export type { ShareCard, ShareOutcome } from './share-card';

/**
 * The link a share carries: a challenge to fight the same opponents. `hl` is
 * the sharer's language, for the link preview only (og/page.php); the friend's
 * game keeps their own.
 */
export function challengeUrl(token: string, kind: string): string {
  return `${GAME_URL}?c=${token}&hl=${currentLang()}&utm_source=share&utm_medium=challenge&utm_campaign=${kind}`;
}

let card: Promise<typeof import('./share-card')> | null = null;

/** Load the share card (once; retried if it failed). */
export function loadShareCard(): Promise<typeof import('./share-card')> {
  card ??= import('./share-card').catch((err: unknown) => {
    card = null;
    throw err;
  });
  return card;
}
